import { gql } from "@apollo/client";export default gql`query topic($id: Int!) {
    topic: group_by_pk(id: $id) {
        id
        description
        cover
        other
        title
        type
        status
        parent_id
    }
}
`;
